import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from "@angular/core";
import { FiatService } from "@main-services/currency";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Fiat, ISwapFee, IVSNFeeTokenCollection } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { CoreModule } from "@modules/core/core.module";
import { Web3Facade } from "@modules/web3/+state/web3.facade";
import { WEB3_FEE_BENEFFIT_FLOW } from "@modules/web3/interface/web3.benefit.ui.interface";
import { VisionFeeTransDetailComponent } from "@modules/web3/ui/vision-fee-trans-detail/vision-fee-trans-detail.component";
import { EMPTY, Observable } from "rxjs";

@Component({
	selector: "fee-transparency-swap-data-ui",
	imports: [CoreModule, VisionFeeTransDetailComponent],
	standalone: true,
	templateUrl: "./fee-transparency-swap-data.component.html",
	styleUrl: "./fee-transparency-swap-data.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeeTransparencySwapDataComponent implements OnInit {
	private fiatService = inject(FiatService);
	private tradableService = inject(TradableListService);
	private web3facade = inject(Web3Facade);

	@Input() data: ISwapFee = null;
	@Input() sourceTradableId: string;
	@Input() targetTradableId: string;
	@Input() vsnFeeCollection: IVSNFeeTokenCollection;

	vsnFeeBenefitFF$: Observable<boolean> = EMPTY;

	isError: boolean = false;
	fiat: Fiat;
	sourceTradable: Tradable;
	targetTradable: Tradable;

	ngOnInit(): void {
		this.checkDataAndTradeType();
		this.vsnFeeBenefitFF$ = this.web3facade.getVSNFeeBenefitFF(WEB3_FEE_BENEFFIT_FLOW.swap);
	}

	private checkDataAndTradeType(): void {
		this.isError = Object.values(this.data).includes(undefined);
		if (!this.isError) {
			this.fiat = this.fiatService.findByPid(this.data?.fiatId);
			this.sourceTradable = this.tradableService.getItemById(this.sourceTradableId);
			this.targetTradable = this.tradableService.getItemById(this.targetTradableId);
		}
	}
}
